import {Inject, Injectable} from '@angular/core';
import {ExtendedFileUploader} from '../services/extendedFileUplaoder.service';
import {IFileManagerConfiguration} from '../configuration/IFileManagerConfiguration';
import {FilemanagerNotifcations} from '../services/FilemanagerNotifcations';
import {Constants} from "../../../helpers/constants";
import {AlertService} from "../../../_services";
import {FileUploaderOptions} from "../../ng2-file-upload/file-uploader.class";

@Injectable()
export class FileManagerUploader {
  public uploader: ExtendedFileUploader;

  public constructor(@Inject('fileManagerConfiguration') configuration: IFileManagerConfiguration,
                     alertService: AlertService) {
    const options: FileUploaderOptions = {
      allowedMimeType: configuration.mimeTypes,
      url: configuration.urls.filesUrl || (window.location.origin || Constants.DefaultApiHost) + '/api/documents/filesAll',
      maxFileSize: configuration.maxFileSize
    };

    this.uploader = new ExtendedFileUploader(options, alertService);
    this.uploader.onAfterAddingFile = (item => {
      //item.withCredentials = false;
      let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      if (currentUser && currentUser.token) {
        item.headers = [{name: 'Authorization', value: `Bearer ${currentUser.token}`}];
      }
    });
  }


  public clear() {
    //this.uploader.authToken = null;
    this.uploader.setOptions(this.getDefaultOptions());
  }

  public getDefaultOptions() {
    const options : FileUploaderOptions= {url:''};
    options['removeAfterUpload'] = true;
    options['autoUpload'] = true;
    options['method'] = 'POST';

    return options;
  }

  public setAuthorizationToken(token: string) {
    //this.uploader.authToken = token;
  }

  public setDirectoryId(directoryId: string | number): FileManagerUploader {
    const options = this.getDefaultOptions();

    options['headers'] = [{name: 'folderId', value: directoryId.toString()}];

    this.uploader.setOptions(options);

    return this;
  }
}
